import { makeStyles } from '@material-ui/core';
import KoneLogo from './logo/kone-logo.svg';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 28,
  },
});

const LogoFull = () => {
  const classes = useStyles();

  return <img className={classes.svg} src={KoneLogo} alt="KONE logo" />;
};

export default LogoFull;
